// extracted by mini-css-extract-plugin
export default {"list":"choose-list_list__Zpbc6","text":"choose-list_text__Kr87D","check_icon":"choose-list_check_icon__ZhUTt"};